import { handleSystemErrorReport } from '@mb/lib/utils';

interface PushFilterAnalyticsProps {
  isReset: boolean;
  resultsNumber: number;
  filter: null | string;
  isAdded: boolean;
}
export const pushFilterAnalytics = ({
  isReset = false,
  resultsNumber = 0,
  filter = null,
  isAdded = false,
}: PushFilterAnalyticsProps) => {
  try {
    if (!filter) {
      return;
    }

    const [attribute, name, postfix] = filter.split(/[.=]/);
    const isDigitalFilter =
      filter === 'filter.sample_type_filter=Free Digital Catalog';
    const defaultName = attribute === 'price_sign_filter' ? postfix : name;

    const initBody = {
      action: '',
      type: '',
      attribute: '',
      name: '',
      results: resultsNumber,
      //refine_search: isFilterAction,
    };
    let body = { ...initBody };
    const actionType = attribute.includes('virtual_color_group')
      ? 'Color'
      : attribute.includes('taxonomy')
      ? 'Category'
      : 'Attribute';

    body['action'] = isAdded ? 'Apply' : 'Removed';
    body['name'] = defaultName?.replaceAll(/\/|>/g, ' - ');
    body['type'] = actionType;
    body['attribute'] = ['virtual_color_group', 'taxonomy'].includes(attribute)
      ? ''
      : attribute;

    if (isDigitalFilter) {
      body['attribute'] = 'digital_sampling';
    }

    if (isReset) {
      body = {
        ...initBody,
        action: 'Clear all',
      };
    }

    const obj = {
      event: 'filter',
      filter: body,
    };
    mitGTM.sendEvent({ filter: null });
    mitGTM.sendEvent(obj);
    console.log(obj);
  } catch (e) {
    handleSystemErrorReport(
      `pushFilterAnalytics error: ${e.message}`,
      'pushFilterAnalytics',
    );
    console.log(e);
  }
};
